import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { PrivacyPolicy } from "./components/Privacy";
import { Terms } from "./components/Terms";

const Home = () => {
    return (
        <div data-testid="home-page" className="min-h-screen bg-white">
            <Navbar />
            <main>
                <Hero />
                <About />
                <Services />
                <Contact />
            </main>
            <Footer />
        </div>
    );
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Toaster position="top-right" richColors />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms" element={<Terms />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
